<template>
  <div class="flex">
    <Component
      :is="badge.component"
      v-for="(badge, badgeIndex) in badges"
      :key="badgeIndex"
      v-tippy="{ content: badge.name }"
      class="h-6 w-6 focus:outline-none dir-ltr:mr-2 dir-rtl:ml-2"
      @click.stop
    />
  </div>
</template>

<script lang="ts" setup>
import { ProductResource } from '@menu/Types/Resources/ProductResource';
import { computed } from 'vue';
import type { Component } from 'vue';
import { trans } from '@menu/Utils/i18n';
import BestsellerBadge from '@menu/Shared/Badges/BestsellerBadge.vue';
import NewBadge from '@menu/Shared/Badges/NewBadge.vue';
import VideoBadge from '@menu/Shared/Badges/VideoBadge.vue';

const props = defineProps<{
  product: ProductResource;
}>();

const badges = computed(() => {
  const badges: {
    name: string;
    component: Component;
  }[] = [];

  if (props.product.isBestseller) {
    badges.push({
      name: trans('Bestseller'),
      component: BestsellerBadge,
    });
  }

  if (props.product.isNew) {
    badges.push({
      name: trans('New'),
      component: NewBadge,
    });
  }

  if (props.product.video) {
    badges.push({
      name: trans('Video available'),
      component: VideoBadge,
    });
  }

  return badges;
});
</script>
